var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaccionesDitoPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transacciones_Dito_Pay",
    "data-name": "Transacciones Dito Pay",
    transform: "translate(-899 -1260)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(899 1260)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "History-WF",
    transform: "translate(928.252 1288.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M28.4,15H32.17V32.818l10.052,10.07a1.885,1.885,0,0,1-2.668,2.664L29.1,35.081a1.88,1.88,0,0,1-.542-1.153l-.008-.179H28.4ZM30.285,0A30,30,0,1,1,.6,34.412a1.885,1.885,0,0,1,3.729-.55A26.22,26.22,0,1,0,6.737,18.406l-.159.338H15.01v3.768H0v-15H3.768v8.433l.126-.237A30.083,30.083,0,0,1,30.285,0Z",
    transform: "translate(1.6 2.22)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaccionesDitoPay);
export default __webpack_public_path__ + "static/media/Transacciones Dito Pay.c89ff986b6019c10b4e72f604484c032.svg";
export { ForwardRef as ReactComponent };